<template>
  <div class="register-header">
    <div class="main-top w">
      <div class="main-top-fl">
        <a href="/">
          <img src="../../../../assets/images/home/logo1.png" alt=""
        /></a>
        <div class="spans">
          <span class="span-1">正见·正心·正品</span>
          <span class="jlf2s2b">极联-F2S2B汽配供应链平台</span>
        </div>
      </div>
      <div class="main-top-fr">
        <em> 已有账号 &nbsp;<a href="/login">去登录</a></em>
        <i></i>
        <span>客服热线：187-4993-8350</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    // 收藏
    addFavorite() {
      var url = window.location
      var title = document.title
      var ua = navigator.userAgent.toLowerCase()
      try {
        window.external.addFavorite(url, title)
      } catch (e) {
        try {
          window.sidebar.addPanel(title, url, '')
        } catch (e) {
          alert('收藏失败，此操作被浏览器拒绝！\n请使用Ctrl+D进行收藏！')
        }
      }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
.register-header {
  border-bottom: 2px solid #377cf1;
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .main-top {
    display: flex;
    padding-top: 39px;
    padding-bottom: 20px;
    .main-top-fl {
      display: flex;
      align-items: flex-end;
      font-family: Source Han Sans CN;
      font-size: 14px;
      color: #787878;
      flex: 1;
      img {
        width: 120px;
        height: 39px;
        margin-right: 12px;
      }
      .spans {
        padding-top: 10px;
        letter-spacing: 4px;
        span:first-child {
          color: #b7b7b7;
          padding-right: 13px;
          letter-spacing: 4px;
        }
        .jlf2s2b {
          width: 211px;
          height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #787878;
          letter-spacing: 3px;
        }
      }
    }
    .main-top-fr {
      margin-right: auto;
      padding-top: 62px;
      a {
        color: #377cf1;
        font-weight: 400;
        font-size: 14px;
        font-family: Source Han Sans CN;
      }
      // span {
      //   cursor: pointer;
      // }
      // span:hover {
      //   color: #e90d0d;
      // }
      i {
        width: 0px;
        height: 18px;
        border: 1px solid #cfcfcf;
        opacity: 1;
        margin: 0 10px 0 11px;
      }
    }
  }
}
</style>
